﻿import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

import { generate_unique_id, str_isEmpty } from '@Util/Utils';

import { Multiselect_With_Checkboxes_Props } from '@Util/Types';


const ITEM_HEIGHT: number = 50;
const ITEM_PADDING_TOP: number = 5;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function Multiple_Select_Checkmarks(props: Multiselect_With_Checkboxes_Props): JSX.Element {
    const element_id: string = props?.id ?? generate_unique_id();

    function generate_element_class(): string {
        let class_str: string = "Form_Row";

        if (!str_isEmpty(props?.className)) {
            class_str += ` ${props.className}`;
        }

        return class_str;
    }

    return (
        <div className={generate_element_class()}>
            <InputLabel id={element_id}>{props.label}</InputLabel>
            <Select
                labelId={generate_unique_id()}
                id={element_id}
                multiple
                value={props.value}
                onChange={props.onChange}
                input={<OutlinedInput label={props.label} />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
            >
                {props?.options?.map((option): JSX.Element => (
                    <MenuItem key={generate_unique_id()} value={option}>
                        {
                            props?.value &&
                            <Checkbox checked={props.value.indexOf(option) > -1} />
                        }
                        <ListItemText primary={option} />
                    </MenuItem>
                ))}
            </Select>
        </div>
    );
}